import { render } from "./SketchfabControls.vue?vue&type=template&id=7b455bff"
import script from "./SketchfabControls.vue?vue&type=script&lang=js"
export * from "./SketchfabControls.vue?vue&type=script&lang=js"
script.render = render

export default script